export type CookieCategory =
  | "necessary"
  | "functional"
  | "analytics"
  | "marketing"
  | "third_party";

export const OPTIONAL_CATEGORIES: CookieCategory[] = [
  "functional",
  "analytics",
  "marketing",
  "third_party",
];

export const ALL_CATEGORIES: CookieCategory[] = ["necessary", ...OPTIONAL_CATEGORIES];

export type ConsentAction = "accept_all" | "reject_optional" | "custom" | "revoke";

export interface ConsentState {
  /** True for each category the user accepted. `necessary` is always true. */
  categories: Record<CookieCategory, boolean>;
  /** Policy version this decision was made against. */
  policyVersion: string;
  /** ISO timestamp of the decision. */
  decidedAt: string;
  /** Last action the user took. */
  action: ConsentAction;
  /** Stable anonymous device id (used when no user is logged in). */
  anonymousId: string;
}

export interface ConsentContextValue {
  /** `undefined` while we're still bootstrapping from storage. */
  state: ConsentState | undefined;
  /** True when the banner should be visible. */
  needsDecision: boolean;
  /** True when the preferences dialog is open. */
  managerOpen: boolean;
  openManager: () => void;
  closeManager: () => void;
  acceptAll: () => Promise<void>;
  rejectOptional: () => Promise<void>;
  saveCustom: (categories: Partial<Record<CookieCategory, boolean>>) => Promise<void>;
  revoke: () => Promise<void>;
  /** Fast helper for runtime gating of scripts. */
  canLoad: (category: CookieCategory) => boolean;
}

export const STORAGE_KEY = "aicavite-consent-v1";
export const ANON_ID_KEY = "aicavite-anon-id";
